import enums from "./../enums";

const initialState = {
	info: {
		team: null,
		stats: null,
	},
	mostPlayedEvents: [],
	upcomingEvents: [],
	topLiveEvents: [],
	casinoStatistics: {
		latestCasinoWins: [],
		highestCasinoWins: [],
	},
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case enums.TEAM_STATS: {
			const info = { ...state.info };
			info.stats = payload;
			return { ...state, info };
		}

		case enums.TEAM_INFO: {
			const info = { ...state.info };
			info.team = payload;
			return { ...state, info };
		}

		case enums.MOST_PLAYED_GAMES: {
			return { ...state, mostPlayedEvents: payload.mostPlayedEvents };
		}
		case enums.UPCOMING_EVENTS: {
			return { ...state, upcomingEvents: payload };
		}
		case enums.TOP_LIVE_EVENTS: {
			return { ...state, topLiveEvents: payload };
		}
		case enums.LAST_WINNERS: {
			return { ...state, casinoStatistics: payload };
		}

		default:
			return state;
	}
};
